import React from "react";
import {
    customDateFormat,
    drawTableArticleType,
    drawTableTitleCell,
    getPointCellInfo,
    fphoto
} from "../../helper/common";
import styles from "./card.module.css";
import strings from "../../lang/strings";
import useIsMobile from "../../hooks/useIsMobile";
import { MaleUrl } from "../../config/const";

export const BjTableCard = ({ header, data, onTitleClick, onBJClick }) => {
    const isMobile = useIsMobile(1030);
    if (!isMobile) return null;

    return (
        <div className={styles.cardList}>
            {data.map((info, idx) => {
                const pointInfo = getPointCellInfo(info);
                const is_special = info.dat_is_betting === '1' || info.dat_is_betting === 1;
                return (
                    <div key={idx} className={styles.card} onClick={() => onTitleClick?.(info)}>
                        <div className="d-flex align-items-center" style={{ justifyContent: 'space-between' }}>
                            <div className={styles.articleBox}>
                                {
                                    is_special &&
                                    <div style={{ background: 'RGB(233, 65, 82)', color: '#fff', padding: '2px 4px', fontWeight: '500', borderRadius: '4px', fontSize: '11px' }}>Special</div>
                                }
                                <div style={info.dat_cate == 4 ? { color: '#D24646' } : info.dat_cate == 5 ? { color: '#0f4c81' } : ""}>
                                    {
                                        info.dat_cate == 4 ? strings.article_type_pm : info.dat_cate == 5 ? strings.article_type_eve : ""
                                    }
                                </div>
                            </div>

                            <div className={styles.createdAt}>
                                {customDateFormat(info.dat_createdat)}
                            </div>
                        </div>


                        {/* ✅ 제목 */}
                        <div className={styles.title}>
                            {info.data_new == 1 && <img className='icon_new2' src='/assets/image/new_bk.png' alt='' style={{ top: '-2px', position: 'relative', marginRight: '4px' }} />}
                            {info.dat_title}
                        </div>



                        <div className={styles.footer}>
                            <div className={styles.nick} onClick={(e) => {
                                if (onBJClick) {
                                    e.stopPropagation();
                                    onBJClick(info);
                                }

                            }}>
                                <img
                                    src={fphoto(info.mb_photo, 'member', MaleUrl)}
                                    alt="프로필"
                                    className={styles.avatar}
                                />
                                {info.mb_nick}
                            </div>

                            <span
                                className={styles.pointValue}
                                style={{ color: pointInfo.color }}
                            >
                                {pointInfo.value}
                            </span>
                        </div>

                    </div>
                );
            })}
        </div>
    );
};
